import { create } from 'zustand';

interface UIStore {
  // Sidebar
  sidebarExpanded: boolean;

  // Modal
  activeModal: string | null;
  modalData: unknown;

  // Loading/Error
  isLoading: boolean;
  error: string | null;

  // Actions
  toggleSidebar: () => void;
  setSidebarExpanded: (expanded: boolean) => void;
  openModal: (modal: string, data?: unknown) => void;
  closeModal: () => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
}

export const useUIStore = create<UIStore>((set) => ({
  sidebarExpanded: false,
  activeModal: null,
  modalData: null,
  isLoading: false,
  error: null,

  toggleSidebar: () => set((state) => ({ sidebarExpanded: !state.sidebarExpanded })),
  setSidebarExpanded: (expanded) => set({ sidebarExpanded: expanded }),
  openModal: (modal, data) => set({ activeModal: modal, modalData: data }),
  closeModal: () => set({ activeModal: null, modalData: null }),
  setLoading: (loading) => set({ isLoading: loading }),
  setError: (error) => set({ error }),
}));

export default useUIStore;
